import { Slider } from '@base-ui/react/slider';
import styles from './CampoSlider.module.css';

type CampoSliderProps = {
  range: [number] | [number, number];
  onChange: (range: [number, number]) => void;
  min?: number;
  max?: number;
  step?: number;
  subSteps?: number;
  mode?: 'single' | 'range';
};

export const CampoSlider = ({
  range = [0],
  onChange,
  min = 0,
  max = 100,
  step = 1,
  subSteps = 0,
  mode = 'range',
}: CampoSliderProps) => {
  // Base-UI Slider usa number | number[]; adaptamos para a API do CampoSlider
  const sliderValue: number | number[] = mode === 'range' || range.length > 1
    ? (range as number[])
    : range[0];

  const handleValueChange = (newValue: number | number[]) => {
    if (Array.isArray(newValue)) {
      onChange([newValue[0], newValue[1]] as [number, number]);
    } else {
      onChange([newValue, range[1] ?? newValue] as [number, number]);
    }
  };

  const stepCount = Math.round((max - min) / step);

  return (
    <Slider.Root
      value={sliderValue}
      onValueChange={handleValueChange}
      min={min}
      max={max}
      step={step}
      className={styles.container}
    >
      <Slider.Control className={styles.control}>
        <Slider.Track className={styles.track}>
          <Slider.Indicator className={styles.indicator} />
          {Array.isArray(sliderValue)
            ? sliderValue.map((_, i) => (
              <Slider.Thumb key={i} className={styles.thumb} />
            ))
            : <Slider.Thumb className={styles.thumb} />}
        </Slider.Track>
      </Slider.Control>

      {stepCount > 0 && stepCount <= 100 && (
        <div className={styles.steps}>
          {Array.from({ length: stepCount + 1 }, (_, i) => (
            <div
              key={i}
              className={
                subSteps === 0 || i % subSteps === 0
                  ? styles.stepMark
                  : styles.subStepMark
              }
            />
          ))}
        </div>
      )}
    </Slider.Root>
  );
};
